import React, { useEffect, useState } from "react";
import "./HighlightProductCollection.css";
import { useNavigate } from "react-router-dom";
import CategoryCard from "../../CustomComponents/CategoryCard";

const HighlightProductCollection = ({ data }) => {
  const navigate = useNavigate();
  const [highlightProductCollection, setHighlightProductCollection] = useState(
    []
  );

  useEffect(() => {
    if (data) {
      setHighlightProductCollection(data);
    }
  }, [data]);

  const handleIndividualCategory = (prod) => {
    navigate(`/productsList/${prod.product_category_id}`, {
      state: {
        subCategoryId: prod.product_category_id,
        subCategoryName: prod.product_category_name,
      },
    });
  };
  // const handleViewAllClickFunc = () => {
  //   navigate("/all-categories-listing", {
  //     state: { fromNosePinCollection: true },
  //   });
  // };
  const handleViewAllClickFunc = (dataaa) => {
    navigate("/nosepin-collection", {
      state: { fromNosePinCollection: true, nosePinCollectionData: dataaa },
    });
  };
  return (
    <div className="nosepin-collection">
      <div className="shopByCategoryDiv">
        <div className="upperContent">
          <h1>Nose pin Collection</h1>
          <p>Delicate and elegant, explore our stunning nosepin collection</p>
        </div>
        <div className="lowerContent">
          <div className="hrLine" />
          <div className="view-all">
            <p
              onClick={() => handleViewAllClickFunc(highlightProductCollection)}
            >
              View all
            </p>
          </div>

          {highlightProductCollection?.length > 0 ? (
            <div className="cardsContainer">
              {" "}
              {/* ✅ All cards inside one container */}
              {highlightProductCollection?.map((prod, index) => (
                <CategoryCard
                  key={prod.id}
                  item={{
                    image: `${prod?.product_category_storage_url}`,
                    name: prod.product_category_name,
                  }}
                  onClick={() => handleIndividualCategory(prod)}
                />
              ))}
            </div>
          ) : (
            <>
              <p>No Nosepin collections available</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HighlightProductCollection;
